module.exports = __webpack_public_path__ + "media/images/photos-btn-4e2815c3ea06ef52050becbf2249c8ad.svg";